import { mapActions, mapGetters, mapMutations } from 'vuex';
import { REGION_ID_MAPPING, REGIONS } from 'Classes/Constants';

import {
  UPDATE_MAP_CENTER,
  UPDATE_MAP_ZOOM,
  UPDATE_SELECTED_DELIVERY_POINT,
  UPDATE_STORE_MARKER,
  UPDATE_WOOS_SCRIPT_LOADED
} from 'Stores/types/mapMutationsTypes';

import { SEARCH_WOOS_DELIVERY_POINTS } from 'Stores/types/mapActionsTypes';

export default {
  data() {
    return {
      userMarker: null,
      storeMarker: null,
      loadedResources: {
        multisearchWidget: false,
        map: false,
        style: false,
      },
    };
  },
  computed: {
    ...mapGetters('map', [
      'getWoosDlpList',
      'getWoosMap',
      'getUserAddress',
      'getWoosScriptIsLoaded',
      'getAllDlpList',
    ]), ...mapGetters('homeDelivery', [
      'getHomeDeliveryAddress'
    ]),
  },
  methods: {
    ...mapMutations('map', {
      UPDATE_MAP_CENTER,
      UPDATE_MAP_ZOOM,
      UPDATE_STORE_MARKER,
      UPDATE_SELECTED_DELIVERY_POINT,
    }), ...mapActions('map', {
      SEARCH_WOOS_DELIVERY_POINTS,
    }),
    initializeWoosMap() {
      this.$store.commit(`map/${UPDATE_WOOS_SCRIPT_LOADED}`, false);

      return new Promise((resolve, reject) => {
        const loadResource = (url, resourceName, isStyle = false) => {
          return new Promise((resolve, reject) => {
            if (this.loadedResources[resourceName]) return resolve();

            const resource = document.createElement(isStyle ? 'link' : 'script');
            if (isStyle) {
              resource.rel = 'stylesheet';
              resource.href = url;
            } else {
              resource.src = url;
            }

            resource.onload = () => {
              this.loadedResources[resourceName] = true;
              resolve();
            };
            resource.onerror = () => {
              reject(new Error(`Failed to load the resource ${resourceName}`));
            };

            document.head.append(resource);
          });
        };

        const url1 = 'https://sdk.woosmap.com/multisearch/multisearch.js';
        const url2 = `https://sdk.woosmap.com/map/map.js?key=${import.meta.env.VITE_WOOS_MAP_KEY}`;
        const urlStyle = 'https://sdk.woosmap.com/localities/style.2.0.css';

        Promise.all([
          loadResource(url1, 'multisearchWidget'),
          loadResource(url2, 'map'),
          loadResource(urlStyle, 'style', true),
        ])
          .then(() => {
            this.$store.commit(`map/${UPDATE_WOOS_SCRIPT_LOADED}`, true);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
    boundDlpS({
      animate = true,
      all = false,
      regionId = null,
    } = {}) {
      if (!this.getWoosScriptIsLoaded || !this.getWoosDlpList || this.getWoosDlpList.length === 0) return;
      const bounds = new woosmap.map.LatLngBounds();

      // Select either all DLPs or filter to closest ones
      // If the list is too large, use the full list instead of the filtered one
      // (because woosmap search is limited to 300 results https://developers.woosmap.com/products/search-api/get-started/#overview)
      let dlps = this.getWoosDlpList.length < 300 ? this.getWoosDlpList
        .map((dlp) => {
          const regionId = Number(dlp.properties?.store_id.split('_')[0]);
          const id = Number(dlp.properties?.store_id.split('_')[1]);
          return this.getAllDlpList.find((d) => d.id === id && d.regionId === regionId) || null;
        })
        .filter((dlp) => dlp) : this.getAllDlpList;

      if (!all && regionId) {
        dlps = dlps.filter((dlp) => dlp.regionId === regionId);
      } else if (!all) {
        dlps = dlps
          .filter((dlp) => !dlp.properties || dlp.properties.distance < 10000)
          .slice(0, 8);
      }

      const dlpCoordinates = dlps
        .filter((dlp) => dlp?.geometry?.coordinates || (dlp.lng && dlp.lat))
        .map((dlp) => {
          return dlp?.geometry?.coordinates || [
            dlp.lng,
            dlp.lat
          ];
        });

      // Include user search coordinates in the bounds
      if (this.getUserAddress) {
        dlpCoordinates.push([
          this.getUserAddress.geometry.location.lng,
          this.getUserAddress.geometry.location.lat
        ]);
      }

      dlpCoordinates.forEach((coordinates) => bounds.extend(new woosmap.map.LatLng(coordinates[1], coordinates[0])));
      // calculate a padding based on the bound, the smaller the bound, the bigger the padding. ne pas utiliser distanceTo
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const dx = ne.lng() - sw.lng();
      const dy = ne.lat() - sw.lat();
      const approxDistance = Math.sqrt(dx * dx + dy * dy) * 111000;
      // quand approxDistance = 20000, padding de 50, quand approxDistance = 0, padding de 150
      // entre, faire progression linéaire
      const padding = Math.max(50, 150 - (approxDistance / 20000) * 100);
      this.getWoosMap.fitBounds(bounds, {
        top: padding,
        bottom: padding,
        left: padding,
        right: padding
      }, animate);
      if (all || regionId) this.SEARCH_WOOS_DELIVERY_POINTS(regionId ? REGION_ID_MAPPING[regionId]?.center : REGION_ID_MAPPING[REGIONS.IDF]?.center);
    },
    focusSelectedDeliveryPoint({ zoomLevel } = {}) {
      if (this.getSelectedDeliveryPoint) {
        this.UPDATE_MAP_ZOOM(zoomLevel);
        const {
          lat,
          lng
        } = this.getSelectedDeliveryPoint?.isHomeDelivery ? this.getHomeDeliveryAddress : this.getSelectedDeliveryPoint;
        this.UPDATE_STORE_MARKER({
          lat,
          lng
        });
        this.UPDATE_MAP_CENTER({
          lat,
          lng
        });
      }
    },
  },
};
